module.exports = __webpack_public_path__ + "static/media/p3_img2.6815e1a6.png";